import { render, staticRenderFns } from "./MealDesign.vue?vue&type=template&id=a0b09e4c&scoped=true&"
import script from "./MealDesign.vue?vue&type=script&lang=js&"
export * from "./MealDesign.vue?vue&type=script&lang=js&"
import style0 from "./MealDesign.vue?vue&type=style&index=0&id=a0b09e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b09e4c",
  null
  
)

export default component.exports